import React from 'react';
import { Box } from 'grommet';

function DetailsPanel() {
  return <Box width="240px">Details</Box>;
}

export default DetailsPanel;
